import { Component } from "react";

interface IBTDraggerContentProps {
    /**
     * @example ["*"] // all files
     * @example ["jpg", "gif", "doc", "docx"]
     */
    allowedFileTypes: string[];
    description: string;
    isPreferred?: boolean;
}

export class BTDraggerContent extends Component<IBTDraggerContentProps> {
    render() {
        const { allowedFileTypes, description, isPreferred } = this.props;
        const prefixDescription = isPreferred ? "Preferred" : "Supported";
        return (
            <>
                <p>{description}</p>
                <p>
                    {prefixDescription} file types -{" "}
                    {allowedFileTypes.map((t) => "." + t).join(", ")}
                </p>
            </>
        );
    }
}
